import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import '../../styles/GlobalThemeStyleCQ';
import {
	Card,
	Button,
	Radio,
	Avatar,
	Upload,
	Collapse,
	Modal,
	Drawer,
	Tabs,
	Timeline,
	Tooltip,
} from 'antd';
import { CardActionArea } from '@mui/material';
export const XThemeCardCaseOperations = styled(Card)`
	height: 100%;
	.ant-card-head {
		padding: 20px 24px !important;
		border-bottom: 1px dashed ${({ theme }) => theme.CQColors.borderColor};
	}
	&.bodyScroll {
		.ant-card-body {
			max-height: 420px;
			min-height: 420px;
			overflow: auto;
			&::-webkit-scrollbar {
				width: 2px;
				height: 2px;
				background: ${({ theme }) => theme.CQColors.bodyBg};
			}
			&::-webkit-scrollbar-thumb {
				background: ${({ theme }) => theme.CQColors.secondaryColor};
			}

			&::-webkit-scrollbar {
				width: 2px;
				height: 2px;
				background: ${({ theme }) => theme.CQColors.borderColor};
			}
		}
	}
	.customWidthHeaderWrap {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		.customWidthHeadIcon {
			width: 80px;
			float: left;
		}
		.customWidthHeader {
			width: calc(100% - 80px);
			float: left;
		}
	}
	&.haveHeader {
		.ant-card-head {
			height: 70px !important;
			border-bottom: 1px solid
				${({ theme }) => theme.CQColors.borderColor};
		}
	}
	&.bgColorClinical {
		.ant-card-head {
			background: rgba(14, 76, 136, 0.05);
		}
	}
	&.bgColorCurrentComplaint {
		.ant-card-head {
			background: rgba(239, 128, 72, 0.05);
		}
	}
	&.bgColorDenialProcedure {
		.ant-card-head {
			background: rgba(22, 145, 145, 0.05);
		}
	}
	&.bgColorMedicareCoverage {
		.ant-card-head {
			background: rgba(97, 175, 74, 0.05);
		}
	}
	&.bgColorMissingInclusionCriteria {
		.ant-card-head {
			background: rgba(65, 14, 136, 0.05);
		}
	}
	&.bgColorCodingTools {
		.ant-card-head {
			background: rgba(14, 76, 136, 0.05);
		}
	}

	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 10px;
	height: 100%;
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 20px !important;
		}
	}
	.titleHeading {
		font-weight: 500;
		font-size: 16px;
		line-height: 19px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}

	/* Full screen styles when expendProfile is true */
	&.fullScreen {
		position: fixed !important;
		top: 60px !important; /* Account for header height */
		left: ${({ theme, collapsed }) =>
			window.innerWidth <= 991
				? '0'
				: collapsed
				? '80px'
				: '210px'} !important; /* Account for sidebar width */
		right: 0 !important;
		bottom: 0 !important;
		width: ${({ theme, collapsed }) =>
			window.innerWidth <= 991
				? '100%'
				: collapsed
				? 'calc(100% - 80px)'
				: 'calc(100% - 234px)'} !important; /* Adjust width based on sidebar state */
		height: calc(100vh - 60px) !important; /* Subtract header height */
		z-index: 9999 !important;
		border-radius: 0px !important;
		margin: 0px !important;
		overflow: auto !important;
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: ${({ theme }) => theme.CQColors.bodyBg};
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.CQColors.secondaryColor};
		}

		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: ${({ theme }) => theme.CQColors.borderColor};
		}
		.ant-card-body {
			height: 100% !important;
			padding: 20px !important;
		}

		.ant-card-head {
			position: sticky !important;
			top: 0 !important;
			z-index: 10 !important;
			background: ${({ theme }) => theme.CQColors.white} !important;
		}
	}
	&.noCardPadding {
		.ant-card-head {
			margin-bottom: 30px !important;
		}
		.ant-card-body {
			padding: 0px 24px !important;
		}
	}
`;
export const XThemeAvatarName = styled(Avatar)`
	background: ${({ theme }) => theme.CQColors.gradientBg};
	box-shadow: inset 0px 16.8313px 16.8313px rgba(255, 255, 255, 0.4);
	color: ${({ theme }) => theme.CQColors.white};
	width: 55px;
	height: 55px;
	line-height: 55px;
	font-weight: 600;
	font-size: 20px;
`;
export const XThemMainTitle = styled.span`
	margin-left: 10px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	font-family: ${({ theme }) => theme.colors.fontPoppins};
	display: inline-block;
	span {
		font-weight: 500;
		font-size: 14px;
		line-height: 21px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
`;
export const XThemeAddressWrap = styled(Card)`
	width: 100%;
	position: relative;
	background: transparent;
	border: none;
	border-radius: 0px;
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	&.cardHeight {
		max-height: 300px;
		overflow: hidden;
	}
	&.noPadding {
		.ant-card-body {
			padding: 0px !important;
		}
	}
	@media only screen and (max-width: 768.99px) {
		background: transparent;
		border: none;
		.ant-card-body {
			padding: 0px !important;
		}
	}
	.iconWrapper {
		width: 36px;
		height: 36px;
		background: ${({ theme }) => theme.CQColors.white};
		border-radius: 50%;
		text-align: center;
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		float: left;
		margin-right: 10px;
		padding: 8px;
		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
	.heading {
		font-weight: 500;
		font-size: 12px;
		line-height: 21px;
		color: ${({ theme }) => theme.CQColors.themeColor3};
		span {
			font-size: 14px;
			color: ${({ theme }) => theme.CQColors.primaryColor};
		}
		margin-bottom: 15px;
	}
	.highlight {
		background-color: #e1fcef !important;
		color: #14804a !important;
		font-weight: bold;
	}
	&.danger {
		.ant-card-body {
			padding: 10px 15px 10px 30px;
		}
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 24px !important;
		background: rgba(183, 35, 35, 0.1) !important;
		color: #b72323 !important;
		sub {
			position: absolute;
			top: 15px;
			left: 15px;
			font-size: 24px !important;
			line-height: 20px !important;
			margin-right: 5px;
		}
	}
`;
export const XThemeCardSummaryEdit = styled(Card)`
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	background: transparent;
	border-radius: 0px;
	border: none;
	padding: 0px;
	.ant-card-body {
		padding: 0px;
		border-radius: 0px !important;
	}
	&.bodyEditCardScroll {
		.ant-card-body {
			max-height: 200px;
			overflow: hidden;
			/* &::-webkit-scrollbar {
				width: 2px;
				height: 2px;
				background: ${({ theme }) => theme.CQColors.bodyBg};
			}
			&::-webkit-scrollbar-thumb {
				background: ${({ theme }) => theme.CQColors.secondaryColor};
			}

			&::-webkit-scrollbar {
				width: 2px;
				height: 2px;
				background: ${({ theme }) => theme.CQColors.borderColor};
			} */
		}
	}
	.fullScreen {
		.ant-card-body {
			max-height: 100% !important;
			overflow: auto !important;
		}
	}
	.para {
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		margin: 0px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		font-size: 14px;
		font-style: normal;
		padding: 0px;
		font-weight: 500;
		line-height: 30px;
		letter-spacing: -0.02em;
	}
	.readMore button,
	.readMore {
		cursor: pointer;
		float: right;
		margin-top: 15px;
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		display: block !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		text-decoration: none !important;
		margin-left: 0px !important;
		padding-left: 0px !important;
	}
`;
export const XThemeCardSupportingDocument = styled(Card)`
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 0px;
	border: none;
	.ant-card-body {
		padding: 0px !important;
	}
	h2 {
		margin: 0px;
		font-weight: 500;
		font-size: 14px;
		line-height: 28px;
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.uploadDocs {
		width: 100%;
		position: relative;
		background: #f7f8fa;
		border-radius: 10px;
		padding: 15px 20px;
		cursor: pointer;
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.menu2};
		margin-bottom: 15px;
	}
`;
export const XThemeCardBackBgVersion = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	&.activeBg {
		background: ${({ theme }) => theme.colors.bodyBg} !important;
		/* border-left: 5px solid #00729940; */
	}
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 20px !important;
		}
	}
`;
export const XThemeMobileCaseDetailsHeader = styled.div`
	display: none;
	@media only screen and (max-width: 991.99px) {
		display: block;
		.timelineVHistoryWrap {
			display: inline-block;
			align-items: center;
			justify-content: center;
			background: ${({ theme }) => theme.colors.white};
			border-radius: 30px;
			padding: 7px;
		}
	}
`;

export const XThemeMobileTimeVHistoryWrapper = styled(Card)`
	display: none;
	border: none !important;
	@media only screen and (max-width: 991.99px) {
		display: block;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background: ${({ theme }) => theme.colors.white};
		width: 100%;
		height: 100%;
		z-index: 99999;
		border: 0px;
		padding: 10px;
		text-align: left;
		overflow-y: auto;
	}
	.ant-card-head {
		margin-bottom: 10px !important;
		padding: 5px 0px !important;
	}
	.ant-card {
		border: none !important;
	}
	.ant-card-body {
		padding: 0px !important;
		.ant-card-body {
			padding: 0px !important;
			.ant-card-body {
				border-radius: 5px;
				padding: 0px !important;
				.hasPadding {
					border-radius: 5px;
				}
				.ant-card-body {
					padding: 10px !important;
					border-radius: 0px 0px 5px 5px;
				}
			}
		}
	}
`;

// End new theme css

export const XCardBackBg = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 20px !important;
		}
	}
`;

export const XCardBackBgVersion = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;

	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 20px !important;
		}
	}
`;

export const ApprovHeading = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	color: ${({ theme }) => theme.CQColors.themeColor2};
	font-family: ${({ theme }) => theme.CQColors.fontInter};
`;

export const ResponseHeading = styled.span`
	padding: 10px;
	font-size: 14px;
	font-weight: 500;
	line-height: 18px;
	color: ${({ theme }) => theme.CQColors.themeColor3};
	font-family: ${({ theme }) => theme.CQColors.fontInter};
`;

export const XButtonBack = styled(Button)`
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	border-radius: 20px !important;
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	background: ${({ theme }) => theme.CQColors.white};
	box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
	svg,
	img {
		font-size: 16px;
		font-weight: 600;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
		svg,
		img {
			color: ${({ theme }) => theme.CQColors.white} !important;
		}
	}
	@media only screen and (max-width: 768.99px) {
		width: 30px !important;
		height: 30px !important;
		svg {
			font-size: 14px;
			font-weight: 600;
		}
	}
`;
export const XEditTitle = styled.span`
	color: ${({ theme }) => theme.colors.menu2};
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	letter-spacing: 0.36px;
	margin-left: 15px;
	@media only screen and (max-width: 768.99px) {
		margin-left: 10px;
		font-size: 14px;
	}
`;

export const XRadio = styled(Radio)`
	margin-top: 10px;
	color: ${({ theme }) => theme.colors.menu2};
	font-weight: 400;
	font-size: 12px !important;
	line-height: 16px !important;
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: #007299;
		border-color: #007299;
	}
	//
	/* Override disabled radio button color */
	.ant-radio-disabled .ant-radio-inner {
		background-color: #f5f5f5; /* Custom background color */
		border-color: #d9d9d9; /* Custom border color */
	}

	.ant-radio-disabled .ant-radio-inner:after {
		background-color: #bfbfbf; /* Custom checkmark color */
	}

	.ant-radio-disabled span {
		color: #8c8c8c; /* Custom text color */
	}
`;
export const XRadioHeader = styled(Radio)`
	margin-top: 10px;
	color: ${({ theme }) => theme.colors.menu2};
	font-weight: 400;
	font-size: 12px !important;
	line-height: 16px !important;
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		border-color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	&.ant-radio-wrapper-checked {
		span {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
`;
export const XAvatarName = styled(Avatar)`
	background: ${({ theme }) => theme.CQColors.secondaryColor};
	color: ${({ theme }) => theme.colors.white};
`;
export const MainTitle = styled.span`
	margin-left: 10px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme }) => theme.colors.color11};
	font-family: ${({ theme }) => theme.colors.fontPoppins};
	display: inline-block;
	span {
		font-weight: 500;
		font-size: 14px;
		line-height: 21px;
		color: ${({ theme }) => theme.colors.color11};
	}
`;
export const SubTitle = styled.span`
	margin-left: 10px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme }) => theme.colors.color11};
`;
export const ParagraphPage = styled.p`
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	color: ${({ theme }) => theme.colors.color11};
	font-family: ${({ theme }) => theme.colors.fontPoppins};
`;
export const AddressWrap = styled(Card)`
	width: 100%;
	position: relative;
	background: #f7f8fa;
	border-radius: 10px;
	font-family: ${({ theme }) => theme.colors.fontPoppins};
	.heading {
		font-weight: 600;
		font-size: 14px;
		line-height: 21px;
		color: ${({ theme }) => theme.colors.menu2};
		span {
			// padding-left: 5px;
			font-weight: 500;
			color: #57636f;
		}
	}
	.highlight {
		// font-weight: 600;
		// font-size: 14px;
		// line-height: 21px;
		// color: ${({ theme }) => theme.colors.menu2};
		background-color: #e1fcef !important; /* or any highlight color */
		color: #14804a !important;
		font-weight: bold;
		// span {
		// 	// padding-left: 5px;
		// 	font-weight: 500;
		// 	color: #57636f;
		// }
	}
`;
export const CaseFillingTitle = styled.p`
	margin: 0px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	font-weight: 500;
	font-size: 14px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.menu2};
`;

export const CaseTimelineTitle = styled.h1`
	margin: 0px;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.themeColor2};
`;
export const CaseUpdateCard = styled.section`
	width: 100%;
	position: relative;
	hr {
		background: ${({ theme }) => theme.colors.menu2};
	}
	.title {
		font-weight: 400;
		font-size: 13px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.ant-form-item-label label,
	label.ant-form-item-no-colon,
	.ant-form-item-label > label,
	.ant-form-item-label {
		font-family: ${({ theme }) => theme.colors.fontInter};
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 16px !important;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.ant-form-item-control-input {
		min-height: 24px !important;
	}
	.inputBox.ant-picker,
	.ant-input-affix-wrapper,
	.selectBox.ant-select {
		width: 100%;
		background: #ffffff !important;
		border: 1px solid rgba(0, 33, 65, 0.1) !important;
		border-radius: 10px !important;
		font-size: 12px !important;
		color: ${({ theme }) => theme.colors.menu2};
	}
	input.inputText {
		background: #ffffff !important;
	}
	${
		'' /* .ant-form-item-control-input {
		background: #ffffff !important;
		border-radius: 10px !important;
	} */
	}
	.innerCardWrap {
		width: 100%;
		position: relative;
		background: ${({ theme }) => theme.colors.white};
		padding: 15px;
		border: 1px solid rgba(0, 33, 65, 0.1);
		border-radius: 10px;
	}
`;
export const XUpload = styled(Upload)`
	width: 100%;
	position: relative;
	cursor: pointer;
	.ant-upload.ant-upload-select {
		width: 100% !important;
		position: relative;
		height: auto !important;
	}
	.uploadCard {
		width: 100%;
		position: relative;
		background: ${({ theme }) => theme.CQColors.white};
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
		border-radius: 10px;
		padding: 20px 10px;
		text-align: center;
	}
	&.widthAuto {
		width: auto !important;
		.ant-upload.ant-upload-select {
			width: auto !important;
			text-align: center;
		}
		.uploadCard {
			width: auto !important;
			background: rgba(15, 115, 238, 0.05);
			border: 1px solid rgba(0, 33, 65, 0.1);
			border-radius: 10px;
			padding: 30px;
			text-align: center;
		}
	}
`;
export const XCollapseMain = styled(Collapse)`
	.ant-collapse-item .ant-collapse-header {
		background: #fff !important;
		border-radius: 8px !important;
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: #212226;
	}
	.ant-collapse-content {
		width: 100%;
		position: relative;
		padding: 0px 5px 15px 0px;
		max-height: 45vh;
		overflow-y: auto;
		overflow-x: hidden;
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
		&::-webkit-scrollbar {
			width: 3px;
			height: 3px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
	}
`;
export const XButtonWrap = styled.div`
	width: 100%;
	positioon: relative;
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	padding: 10px 15px;
	font-weight: 400;
	font-size: 14px;
	line-height: 28px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.menu2};
`;
export const XButtonModal = styled(Button)`
	background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	svg {
		color: ${({ theme }) => theme.CQColors.white};
	}
	&:hover {
		border-color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;

export const XICDModal = styled(Modal)`
	.ant-modal-close-x {
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterColor};
			color: ${({ theme }) => theme.CQColors.white};
		}
	}
	.icdIcons {
		background: #f5f5f5;
		border-radius: 8px;
		padding: 15px;
		text-align: center;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
	.modalTitle {
		width: 100%;
		position: relative;
		font-weight: 600;
		font-size: 20px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.modalTitleSub {
		width: 100%;
		position: relative;
		font-weight: 500;
		font-size: 20px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.modalParagraph {
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
		color: rgba(33, 34, 38, 0.6);
	}
	.ant-modal-content {
		padding: 24px;
	}
`;
export const XICDModalFooterBTN = styled(Button)`
	width: 100%;
	position: relative;
	background: linear-gradient(
		90deg,
		${({ theme }) => theme.colors.themeColor8} 20.31%,
		${({ theme }) => theme.colors.themeColor25} 100%
	) !important;
	border-color: #fff !important;
	border-radius: 5px !important;
	font-weight: 500 !important;
	font-size: 14px !important;
	line-height: 21px !important;
	text-align: center !important;
	color: ${({ theme }) => theme.colors.white} !important;
	padding: 0px 20px !important;
	box-shadow: none !important;
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: #fff !important;
	}
`;
export const XAddCodeSticky = styled(Button)`
	position: fixed;
	transform: rotate(-90deg);
	right: -42px;
	top: 21%;
	z-index: 1 !important;
	background: ${({ theme }) => theme.CQColors.secondaryColor};
	border: 1px solid rgba(0, 114, 153, 0.1);
	border-radius: 10px 10px 0px 0px;
	font-weight: 400;
	font-size: 14px;
	line-height: 38px;
	color: ${({ theme }) => theme.CQColors.white};
	&:hover {
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
	@media only screen and (max-width: 991.99px) {
		top: 35%;
	}
`;
export const XDrawerAddCode = styled(Drawer)`
	font-family: ${({ theme }) => theme.colors.fontInter} !important;
	.ant-drawer-body {
		padding: 0px !important;
	}
	.ant-drawer-title,
	.ant-drawer-header {
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		background: #f2f8fa;
		border: none;
		font-weight: 600 !important;
	}
	.titleBg {
		width: 100%;
		position: relative;
		background: #f2f8fa;
		padding: 0px 24px 24px 24px;
		border-bottom: 1px dashed #dbdbdb;
	}
	.contentPadding {
		width: 100%;
		position: relative;
		padding: 24px;
	}
	.titleICD {
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.icdPara1 {
		font-weight: 600 !important;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	.icdPara2 {
		font-weight: 400 !important;
		font-size: 12px;
		line-height: 22px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.CQColors.primaryColor};
		.react-read-more-read-less {
			font-weight: 500 !important;
			display: block;
			color: #007299;
		}
	}
	.icdPara3 {
		font-weight: 600 !important;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}
	.btnAdd {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		svg {
			filter: none;
		}
	}
	.ant-drawer-close {
		position: absolute;
		right: 0;
	}
	.ant-drawer-body {
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
		&::-webkit-scrollbar {
			width: 3px;
			height: 3px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
	}
`;
export const XTabIcdCpt = styled(Tabs)`
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	.titleICD {
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.icdPara1 {
		font-weight: 600 !important;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	.icdPara2 {
		font-weight: 400 !important;
		font-size: 12px;
		line-height: 22px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.CQColors.themeColor2};
		.react-read-more-read-less {
			font-weight: 500 !important;
			display: block;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
		}
	}
	.icdPara3 {
		font-weight: 600 !important;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.btnAdd {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		svg {
			filter: none;
		}
	}
	.ant-tabs-nav {
		&:before {
			display: none !important;
		}
	}
	.ant-tabs-nav-wrap {
		display: block !important;
	}
	.ant-tabs-nav-list {
		background: ${({ theme }) => theme.CQColors.white};
		border: 1px solid rgba(0, 114, 153, 0.1);
		border-radius: 10px;
	}
	.ant-tabs-tab {
		width: 50% !important;
		display: block !important;
		text-align: center !important;
		background: none !important;
		border: none !important;
		font-weight: 500;
		font-size: 14px;
		line-height: 26px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		&:hover {
			${
				'' /* background: #007299 !important;
			border-radius: 10px !important; */
			}
			.ant-tabs-tab-btn {
				color: ${({ theme }) =>
					theme.CQColors.secondaryColor} !important;
			}
		}
	}
	.ant-tabs-tab-disabled {
		&:hover {
			.ant-tabs-tab-btn {
				color: rgba(0, 0, 0, 0.25) !important;
			}
		}
	}
	.ant-tabs-tab.ant-tabs-tab-active {
		/* background: #007299 !important; */
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		border-radius: 10px !important;
		.ant-tabs-tab-btn {
			color: #fff !important;
		}
	}
	#stckyScroll {
		overflow-y: scroll !important;
		height: 100%;
		max-height: 85vh !important;
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
		&::-webkit-scrollbar {
			width: 3px;
			height: 3px;
			background: #f4f3f3;
		}
		&::-webkit-scrollbar-thumb {
			background: #9b9b9b;
		}
	}
`;
export const XButtonBackRound = styled(Button)`
	color: ${({ theme }) => theme.colors.menu2};
	border-radius: 10px !important;
	border: 1px solid #f7f8fa;
	background: #f7f8fa;
	box-shadow: none;
	svg {
		font-size: 16px;
		font-weight: 600;
		color: ${({ theme }) => theme.colors.menu2};
	}
	&:hover {
		background: #007299 !important;
		color: ${({ theme }) => theme.colors.white} !important;
		svg {
			color: ${({ theme }) => theme.colors.white};
		}
	}
`;
export const XRelatedCard = styled(Card)`
	background: ${({ theme }) => theme.CQColors.bodyBg};
	margin-bottom: 15px !important;
	// border-bottom: none;
	border-radius: 10px 10px 10px 10px;
	padding: 15px !important;
	.ant-card-body {
		padding: 0px !important;
	}
	${(props) =>
		props.variant === 'CPT'
			? `
			margin-bottom: 0px !important;
			border-bottom: none;
			border-radius: 10px 10px 0px 0px;
			`
			: `
			margin-bottom: 15px !important;
			border-radius: 10px;
			`}
`;
export const XRelatedReadMore = styled(Card)`
	border-top: none;
	border-radius: 0px 0px 10px 10px;
	margin-bottom: 24px !important;
	padding: 40px 15px 15px 15px !important;
	.ant-card-body {
		padding: 0px !important;
	}
	.react-read-more-read-less {
		position: absolute;
		top: -25px;
		width: 100%;
		padding-right: 15px;
	}
`;
export const XCardSupportingDocument = styled(Card)`
	border: 1px solid rgba(87, 99, 111, 0.15);
	border-radius: 10px;
	h2 {
		margin: 0px;
		font-weight: 500;
		font-size: 16px;
		line-height: 18px;
		font-family: ${({ theme }) => theme.colors.fontInter};
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.menu2};
	}
	.uploadDocs {
		width: 100%;
		position: relative;
		background: #f7f8fa;
		border-radius: 10px;
		padding: 15px 20px;
		cursor: pointer;
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.colors.menu2};
		margin-bottom: 15px;
	}
`;

export const RevisionHistoryNum = styled.div`
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	width: 40px;
	height: 40px;
	position: relative;
	border-radius: 40px;
	background-color: ${({ theme }) => theme.CQColors.borderColor};
	color: ${({ theme }) => theme.CQColors.white} !important;
	text-align: center;
	.RevisionNum {
		font-size: 12px;
		font-weight: 500;
		line-height: 40px !important;
		text-align: center;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
`;

export const RevisionHistoryCommentHeading = styled.div`
	display: flex;
	flex-direction: column; /* Arrange children in a vertical stack */
	align-items: flex-start;
	margin-left: 15px;
`;

export const RevisionHisTitle = styled.div`
	font-weight: 600;
	font-size: 13px;
	line-height: 18px;
	margin-left: 10px;
	color: ${({ theme }) => theme.CQColors.themeColor2};
	.revisionHisIcons {
		width: 100%;
		position: relative;
		font-weight: 400;
		font-size: 13px;
		line-height: 20px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
`;
export const EyeIcon = styled(Button)`
	border-radius: 50%;
	background: ${({ theme }) => theme.CQColors.secondaryColor};
	color: ${({ theme }) => theme.CQColors.white};
	border: none !important;
	font-size: 16px;
	&:hover {
		border: none !important;
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;

export const RevisionTimeline = styled(Timeline)`
	margin-top: 10px;
	margin-left: 30px;
	.ant-timeline-item-tail {
		border-left: 2px dashed #e0e0e0 !important; /* Set the line color and dashed style */
	}
`;

export const CurrentRevision = styled.span`
	font-size: 12px;
	text-align: left;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	background: ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 30px;
	padding: 5px 10px;
`;

export const RevisionDot = styled.div`
	width: 5px;
	height: 5px;
	// margin: 13px 9px 32px 3px;
	background-color: #d9d9d9;
	border-radius: 20px;
`;
export const XThemeAvatarText = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.CQColors.themeColor3};
	span {
		margin-right: 5px;
	}
`;
export const XThemeExpendBtn = styled(Button)`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.CQColors.primaryColor};
	border-color: ${({ theme }) => theme.CQColors.borderColor};
	&:hover {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterWhite};
		}
	}
`;

export const XVerHistorySticky = styled(Button)`
	position: fixed;
	right: 24px;
	top: 56px;
	z-index: 1 !important;
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 0px 0px 10px 10px;
	font-weight: 600;
	font-size: 12px;
	line-height: 20px;
	height: auto !important;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	box-shadow: none !important;
	&:hover {
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
	@media only screen and (max-width: 991.99px) {
		/* top: 11.5%;
		right: 10px; */
		display: none;
	}
`;
export const DrawerVersionLog = styled(Drawer)`
	.ant-drawer-title,
	.ant-drawer-header {
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		background: #f2f8fa;
		border: none;
		font-weight: 600 !important;
	}
`;
export const XThemeMotionMode = styled.div`
	/* height: 100vh;
	padding: 2rem; */
	position: relative;
	overflow: hidden;
	.motionOpenBtn {
		position: relative;
		cursor: pointer;
		z-index: 1;
	}
	.motionAnimateWrapper {
		position: fixed;
		top: 60px;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1000;
		// This creates a mask that only covers the main content area
		// The left margin accounts for the sidebar widthdisplay: 'flex',
		align-items: center;
		justify-content: center;
		@media only screen and (max-width: 991.99px) {
			top: 75px;
		}
	}
	.motionBackdrop {
		position: absolute;
		top: 0px;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		z-index: 1000;
		backdrop-filter: blur(4px);
	}
	.motionContent {
		position: absolute;
		top: 20px;
		left: 20px;
		right: 20px;
		bottom: 20px;
		background: ${({ theme }) => theme.CQColors.white};
		z-index: 1001;
		overflow: hidden;
		/* display: flex;
		align-items: center;
		justify-content: center; */
		border-radius: 0px;
		padding: 3rem;
		overflow-y: scroll;
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: ${({ theme }) => theme.CQColors.bodyBg};
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.CQColors.secondaryColor};
		}

		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: ${({ theme }) => theme.CQColors.borderColor};
		}
	}
	.motionCloseBtn {
		position: absolute;
		top: 0.2rem;
		right: 0.2rem;
		cursor: pointer;
		/* float: right; */
		/* position: absolute;
		top: 2rem;
		right: 2rem;
		background: none;
		border: none;
		font-size: 28px;
		cursor: pointer;
		color: #666;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		width
		align-items: center;
		justify-content: center;
		transition: all 0.2s ease; */
	}
`;
